export const initialState = {
  base: {
    allIDs: [],
    byId: {},
  },
  ui: {
    isFetchingOrganization: false,
    isFetchingOrganizations: false,
  },
};

export const organizationSchema = {
  additionalProperties: true,
  properties: {
    afterHours: { type: 'object' },
    businessHours: { items: { type: 'object' }, type: 'array' },
    contactEmail: { type: 'string' },
    contactName: { type: 'string' },
    contactPhoneNumber: { type: 'string' },
    createdAt: { type: 'number' },
    id: { type: 'string' },
    isActive: { type: 'boolean' },
    logo: { type: 'string' },
    name: { type: 'string' },
    organizationId: { type: 'string' },
    salesforceId: { type: 'string' },
    stripeToken: { type: 'string' },
    updatedAt: { type: 'number' },
  },
  type: ['object', 'null'],
};

export const twilioRegistrationsSchema = {
  items: {
    additionalProperties: false,
    properties: {
      id: { type: 'string' },
      legal_business_name: { type: 'string' },
      organization_id: { type: 'string' },
      status: { type: 'string' },
      twilio_account_id: { type: 'string' },
      workspaces: {
        items: {
          properties: {
            id: { type: 'string' },
            mongo_id: { type: 'string' },
            name: { type: 'string' },
          },
          type: 'object',
        },
        type: 'array',
      },
    },
    type: 'object',
  },
  type: 'array',
};
